import { render } from "./DataTitle.vue?vue&type=template&id=ffc89002"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__